import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Typography from '@mui/material/Typography'

// Building blocks for the applicant wizard. FormSection matches the shared
// add-employee cards (Paper, padding 3, `title` heading) that the personal
// details step reuses, so every step reads as one form.

export const FormSection = ({ title, caption, action, children }) => (
  <Paper sx={{ p: { xs: 2, sm: 3 } }}>
    <Stack gap={2}>
      {(title || action) && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          gap={2}
        >
          <Box minWidth={0}>
            {title && <Typography variant="title">{title}</Typography>}
            {caption && (
              <Typography variant="body2" mt={0.5}>
                {caption}
              </Typography>
            )}
          </Box>
          {action && <Box flexShrink={0}>{action}</Box>}
        </Stack>
      )}
      {children}
    </Stack>
  </Paper>
)

// A full-sentence question with Yes / No buttons — long questions stay
// readable instead of being truncated inside a Select label.
export const YesNoQuestion = ({ label, helper, value, onChange, children }) => (
  <Stack gap={1}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      gap={1}
    >
      <Box minWidth={0}>
        <Typography fontWeight={500}>{label}</Typography>
        {helper && <Typography variant="body2">{helper}</Typography>}
      </Box>
      <ToggleButtonGroup
        exclusive
        size="small"
        color="primary"
        value={typeof value === 'boolean' ? value : null}
        onChange={(_, next) => next !== null && onChange(next)}
        sx={{ flexShrink: 0, '& .MuiToggleButton-root': { px: 2.5 } }}
      >
        <ToggleButton value={true}>Yes</ToggleButton>
        <ToggleButton value={false}>No</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
    {children}
  </Stack>
)
